export const alignment = (block) => {
  let alignment = null;

  if (block?.tunes?.AlignmentBlockTune) {
    alignment = block?.tunes?.AlignmentBlockTune?.alignment;
  }

  if (alignment) {
    return `text-${alignment}`;
  } else {
    return ``;
  }
}

export const color = (block, returnColorOnly) => {
  let color = null;

  if (block?.tunes?.FontColorTool) {
    color = block?.tunes?.FontColorTool?.color;
  }
  else if (block?.data?.color) {
    color = block?.data?.color
  }

  if (color) {
    if (returnColorOnly) {
      return color;
    } else {
      return `color: ${color};`;
    }
  } else {
    return ``;
  }
}

export const animation = (block) => {
  let animation = null;

  if (block?.tunes?.Animation) {
    animation = block?.tunes?.Animation?.animation?.class;
  }

  if (animation) {
    return `fragment ${animation}`;
  } else {
    return ``;
  }
}

export const animationIndex = (block, offset) => {
  if (block?.tunes?.Animation?.animationIndex) {
    const index = offset ? block.tunes.Animation.animationIndex + offset : block.tunes.Animation.animationIndex;
    return `data-fragment-index="${index}"`;
  }
  return "";
}

export const dimension = (block) => {
  let dimensions = null
  let tempDimensions = null
  if (block?.data?.dimensions) {
    tempDimensions = { ...block?.data?.dimensions }
    dimensions = {
      width: tempDimensions.width === 'auto' || tempDimensions.width === '0' ? 'auto' : `${tempDimensions.width}px`,
      height: tempDimensions.height === 'auto' || tempDimensions.height === '0' ? 'auto' : `${tempDimensions.height}px`,
    }
  }

  if (dimensions) {
    return `width:${dimensions.width}; height: ${dimensions.height}; object-fit: cover`;
  }
  else {
    return ``;
  }
}

export const blockBgColor = (block) => {
  let bgColor = null

  if (block?.tunes?.BlockBackgroundTool?.bgColor?.name) {
    bgColor = block?.tunes?.BlockBackgroundTool?.bgColor?.name;
  }

  if (bgColor) {
    return bgColor;
  } else {
    return 'blue';
  }
}

export const blockPattern = (block) => {
  let pattern = null;
  if (block?.tunes?.BlockBackgroundTool?.pattern) {
    pattern = block?.tunes?.BlockBackgroundTool?.pattern;
  }

  return pattern;
}

export const headingToggle = (block) => {
  let heading = null

  if (block?.tunes?.HeadingToggleTool?.variant) {
    heading = block?.tunes?.HeadingToggleTool?.variant;
  }

  if (heading) {
    return heading;
  } else {
    return 'heading-title';
  }
}

export const overlayTool = (block) => {
  let overlay = block?.tunes?.OverlayTool;
  let color, opacity

  if (block?.tunes?.OverlayTool) {
    color = overlay?.color;
    opacity = overlay?.opacity;
    return { backgroundColor: color, opacity: opacity }
  }
  else return ''
}

export const draggable = (block) => {
  if (block?.tunes?.DragResize) {
    const style = block.tunes.DragResize.draggable;
    const parseValue = (value) => {
      return typeof value === "string"
        ? parseInt(value.replace("px", ""))
        : value;
    }
    if (style) {
      if (style.absolute) {
        return `position: absolute; top: ${parseValue(style.top)}px; left: ${parseValue(style.left)}px; width: ${parseValue(style.width)}px; height: ${parseValue(style.height)}px;`;
      }
      else {
        if (style.width || style.height) {
          return `width: ${parseValue(style.width)}px; height: ${parseValue(style.height)}px;`;
        }
      }
    }
  }
  else {
    return ""
  }
}

export const mediaDraggable = (block, slideLayoutId) => {
  let draggableStyle = ''
  if (slideLayoutId === 'custom' && (block.data?.tuneData !== 'undefined') && (typeof block.data?.tuneData === 'object')) {
    const customTuneData = block.data?.tuneData;
    const draggableKeys = Object.keys(block.data?.tuneData);
    if (draggableKeys && draggableKeys.length > 0) {
      draggableStyle = 'position: absolute;';
      draggableKeys.forEach((e) => {
        draggableStyle = `${draggableStyle} ${customTuneData[e] !== '' ? `${e}: ${customTuneData[e]};` : ''}`
      })
    }
  }
  return draggableStyle;
}

export const fontSizeTune = (block) => {
  const style = block?.tunes?.FontSizeTune
  if (style && style.fontSize) {
    return `font-size: ${style.fontSize}px;`
  } else {
    return '';
  }
}

export const backdropTune = (block) => {
  const backdrop = block?.tunes?.BackdropTune;
  if (!backdrop) return "";

  const styles = [];

  if (backdrop.padding) {
    const { top, right, bottom, left } = backdrop.padding;
    styles.push(
      `padding: ${top || 0}px ${right || 0}px ${bottom || 0}px ${left || 0}px;`
    );
  }

  if (backdrop.backgroundColor) {
    styles.push(`background-color: ${backdrop.backgroundColor};`);
  }

  if (backdrop.border) {
    const { top, right, bottom, left, color } = backdrop.border;
    const borderColor = color || "#000000";
    styles.push(`border-top: ${top || 0}px solid ${borderColor};`);
    styles.push(`border-right: ${right || 0}px solid ${borderColor};`);
    styles.push(`border-bottom: ${bottom || 0}px solid ${borderColor};`);
    styles.push(`border-left: ${left || 0}px solid ${borderColor};`);
  }

  if (backdrop.borderRadius) {
    const { topLeft, topRight, bottomRight, bottomLeft } = backdrop.borderRadius;
    styles.push(
      `border-radius: ${topLeft || 0}px ${topRight || 0}px ${
        bottomRight || 0
      }px ${bottomLeft || 0}px;`
    );
    
    if(topLeft > 0 || topRight > 0 || bottomRight > 0 || bottomLeft > 0 ){
      styles.push("overflow: hidden;")
    }
  }

  if (backdrop.boxShadow) {
    const { x, y, blur, spread, color, inset } = backdrop.boxShadow;
    styles.push(
      `box-shadow: ${inset ? "inset " : ""}${x || 0}px ${y || 0}px ${
        blur || 0
      }px ${spread || 0}px ${color || "#000000"};`
    );
  }

  return styles.join(" ");
};